<div class="container register-complete">
    <!-- <div>
        <app-registration-bread-crumb [startAt]="4" ></app-registration-bread-crumb>
    </div> -->
    <div class="complete-register">
        <h2 class="title-label">Thank you for Registering!</h2>
        <div class="center-paragraph">
            <div>
                Your registration is successfully subitted and. 
            </div>
            <div>
                <p>
                   you will get an email notification when the account approved.
                </p>
            </div>
        </div>
        <div class="back-to-login-btn">
            <button class="button"  (click)="redirectLogin()" style="background-color: rgb(94, 195, 208);">Back to Login</button>
        </div>
    </div>
</div>

